import { FormTextarea } from "@jsq/ds/forms";

interface Props {
  isRequired?: boolean;
  readonly: boolean;
}

const DescriptionOnlyFormValues = ({ isRequired = false, readonly }: Props) => {
  return (
    <FormTextarea
      isFullWidth
      disabled={readonly}
      name="description"
      label={isRequired ? "Description" : "Description (Optional)"}
    />
  );
};

export default DescriptionOnlyFormValues;
